import { Clock3 } from "lucide-react";
import React from "react";

import { cn } from "../../../lib/utils";

export interface TimeAgoPillProps {
  days: string;
  className?: string;
  showLeftIcon?: boolean;
}

const TimeAgoPill: React.FC<TimeAgoPillProps> = ({
  days: text,
  className,
  showLeftIcon = true,
}) => {
  return (
    <span
      className={cn(
        "inline-flex h-5 min-w-[87px] flex-none items-center justify-center gap-1 whitespace-nowrap rounded-lg bg-orange-200 px-2 py-0.5 font-sans text-xs font-medium leading-4 tracking-normal text-orange-700",
        className,
      )}
    >
      {showLeftIcon ? (
        <span
          className="flex h-3 w-3 flex-none items-center justify-center"
          aria-hidden="true"
        >
          <Clock3 className="h-3 w-3" strokeWidth={2.5} />
        </span>
      ) : null}
      <span>{text} day ago</span>
    </span>
  );
};

export default TimeAgoPill;
